module.exports = __webpack_public_path__ + "static/media/2026_WA-Footy-Lives-Here-Banner-Mobile-@2x.9bc963b5.webp";